module.exports = __webpack_public_path__ + "img/quote.02520720.svg";